var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05071 1.01694H6.44052C6.72116 1.01694 6.94899 0.789109 6.94899 0.508472C6.94899 0.227834 6.72116 0 6.44052 0H3.05071C2.77007 0 2.54224 0.227834 2.54224 0.508472C2.54224 0.789109 2.77007 1.01694 3.05071 1.01694Z",
    fill: "#A7A7A7",
    fillOpacity: 0.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01679 2.71189V8.30508C1.01679 9.24098 1.7758 9.99998 2.71169 9.99998H6.77947C7.71537 9.99998 8.47437 9.24098 8.47437 8.30508V2.71189H9.03203C9.28559 2.71189 9.49132 2.48406 9.49132 2.20342C9.49132 1.92278 9.28559 1.69495 9.03203 1.69495H0.45929C0.205732 1.69495 0 1.92278 0 2.20342C0 2.48406 0.205732 2.71189 0.45929 2.71189H1.01694H1.01679ZM3.38966 3.89832V7.9661C3.38966 8.15322 3.54152 8.30508 3.72864 8.30508C3.91576 8.30508 4.06762 8.15322 4.06762 7.9661V3.89832C4.06762 3.7112 3.91576 3.55934 3.72864 3.55934C3.54152 3.55934 3.38966 3.7112 3.38966 3.89832ZM5.42354 3.89832V7.9661C5.42354 8.15322 5.5754 8.30508 5.76253 8.30508C5.94965 8.30508 6.10151 8.15322 6.10151 7.9661V3.89832C6.10151 3.7112 5.94965 3.55934 5.76253 3.55934C5.5754 3.55934 5.42354 3.7112 5.42354 3.89832Z",
    fill: "#A7A7A7",
    fillOpacity: 0.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.c184a0cd196522c0dcffdbb754369867.svg";
export { ForwardRef as ReactComponent };